import { render, staticRenderFns } from "./ChooseAsset.vue?vue&type=template&id=229e6036&"
import script from "./ChooseAsset.vue?vue&type=script&lang=js&"
export * from "./ChooseAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChooseAsset.vue"
export default component.exports